import { useState } from 'react';
import { Dropdown } from 'react-bootstrap';
import { BsThreeDotsVertical } from 'react-icons/bs';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { selectDoctor, selectFunc } from 'redux/features/auth/authSlice';
import { atualizarAgenda } from 'services/agenda';
import history from 'services/history';
import { useSWRConfig } from 'swr';
import useSWRMutation from 'swr/mutation';
import { resolveUsuarioAgenda } from 'utils/agenda';
import { getApiErrorMessage } from 'utils/apiErrors';
// import { enviarMensagem, toWhatsappNumber } from 'utils/evolution';
// import { obterNomeTratado } from 'utils/helpers';
import { navigateToProntuario } from 'utils/prontuarioNav';
import FaturamentoModal from './FaturamentoModal';

const STATUS_CODFUNC_FIELD = {
  Cancelado: 'codFuncCancelou',
  Faltou: 'codFuncMarcou',
  'Em Atendimento': 'codFuncMarcou',
  'Não Realizou': 'codFuncMarcou',
  Reservado: 'codFuncMarcou',
  Encaminhado: 'codFuncMarcou',
  Faturado: 'codFuncMarcou',
  Atendido: 'codFuncAtendido',
  AltoCusto: 'codFuncAtendido',
  Marcada: 'codFuncAgenda',
  Desmarcada: 'codFuncAgenda',
  Solicitado: 'codFuncMarcou',
  Encaminhado: 'codFuncMarcou',
  Chamado: 'codFuncMarcou',
  Laudado: 'codFuncAtendido',
};

const DROPDOWN_ITEM_STYLE = { padding: '0.15rem 0.5rem', fontSize: '0.9rem' };

export default function PopupMenu({ agenda, onOpenAgenda, verCanceladas, onToggleCanceladas }) {
  const func = useSelector(selectFunc);
  const doctor = useSelector(selectDoctor);
  const { mutate } = useSWRConfig();

  const [showFaturamentoModal, setShowFaturamentoModal] = useState(false);
  const [showAdvanced, setShowAdvanced] = useState(false);

  const atualizarTabelaAgenda = () =>
    mutate((key) => Array.isArray(key) && key[0] === '/medico/agendas');

  const { trigger } = useSWRMutation('/agenda', atualizarAgenda, {
    onSuccess: atualizarTabelaAgenda,
    onError: (err) => toast.error(getApiErrorMessage(err, 'Erro ao atualizar agenda')),
    throwOnError: false,
  });

  const { codFunc, nome: nomeFunc } = resolveUsuarioAgenda({ func, doctor });

  /*   const medicoInfo = useMemo(() => {
      return (
        listaMedicos.find((m) => String(m.codMed) === String(agenda.CODMED)) || {
          apelido: 'Médico',
          sala: 'Recepção',
        }
      );
    }, [agenda.CODMED]); */

  const atualizarCampo = (campo, valor) => trigger({ codAgenda: agenda.CODAGENDA, [campo]: valor });

  const atualizarSituacao = (situacao) => {
    const codFuncField = STATUS_CODFUNC_FIELD[situacao];
    trigger({
      codAgenda: agenda.CODAGENDA,
      ...(situacao !== 'Faturado' ? { situacao } : {}),
      ...(codFuncField && codFunc ? { [codFuncField]: codFunc } : {}),
      evolucao: `${nomeFunc} - ${situacao}`,
    });
  };

  /*   const handleNovagenda = async () => {
      try {
        const response = await inserirEncaixe({
          codMedico: Number(agenda?.CODMED),
          dataAgenda: new Date(agenda?.DATAAGENDA).toISOString().split('T')[0],
          horario: Number(agenda?.HORARIO) + 1,
          codFunc,
        });
        await atualizarTabelaAgenda();
        toast.success(response?.mensagem || 'Encaixe registrado com sucesso.');
      } catch (err) {
        console.error('Erro ao inserir encaixe:', err);
        toast.error('Não foi possível registrar o encaixe.');
      }
    }; */

  /*   const handleChamarPaciente = async () => {
      const nomeTratado = obterNomeTratado(agenda.NOME, agenda.SEXOPAC, agenda.DTNPAC);
      const mensagem = `Olá, *${nomeTratado}*!\n*${medicoInfo.apelido}* já está aguardando por você na Sala *${medicoInfo.salaId}*.\nFique à vontade para se dirigir até a sala. Se precisar de qualquer auxílio, nossa equipe está à disposição. Seja bem-vindo! ❤️`;
      const celularWhats = toWhatsappNumber(agenda.CELULARPAC || agenda.TELEFONE);
  
      const result = await enviarMensagem({
        to: celularWhats,
        text: mensagem,
        pacienteNome: nomeTratado,
        medicoNome: medicoInfo.apelido,
        sala: medicoInfo.salaId,
      });
  
      if (result?.success) {
        toast.success(result.message);
        atualizarSituacao('Chamado');
      } else {
        toast.error(result?.message || 'Erro ao enviar mensagem.');
      }
    }; */

  const handleAtividades = () => {
    // Monta os parâmetros com codFunc e nomeFunc devidamente codificados
    const params = new URLSearchParams({
      codpac: agenda.CODPAC,
      nomePaciente: agenda.NOME || '',
      ...(codFunc ? { codFunc } : {}),
      ...(nomeFunc ? { nomeFunc } : {}),
    });

    history.push(`/atividades?${params.toString()}`);
  };

  const handleProntuario = () => navigateToProntuario(agenda.CODPAC, { agendaSelecionada: agenda });

  return (
    <>
      <Dropdown
        className="m-0 p-0 d-inline-flex"
        onClick={() => onOpenAgenda?.(agenda, { forceShow: false })}
      >
        <Dropdown.Toggle
          variant="link"
          id={`dropdown-${agenda.CODAGENDA}`}
          className="p-0 m-0 border-0 no-caret d-flex align-items-center justify-content-center"
          style={{ lineHeight: 1, boxShadow: 'none' }}
        >
          <BsThreeDotsVertical className="text-secondary" size={12} />
        </Dropdown.Toggle>

        <Dropdown.Menu>
          <Dropdown.Item
            onClick={handleProntuario}
            className="text-dark text-center"
            style={DROPDOWN_ITEM_STYLE}
          >
            PRONTUÁRIO
          </Dropdown.Item>
          <Dropdown.Divider style={{ margin: '0.2rem 0' }} />
          <Dropdown.Item
            onClick={handleAtividades}
            className="text-success text-center"
            style={DROPDOWN_ITEM_STYLE}
          >
            ATIVIDADES
          </Dropdown.Item>

          <Dropdown.Divider style={{ margin: '0.2rem 0' }} />

          <Dropdown.Item
            onClick={(e) => {
              e.stopPropagation();
              onOpenAgenda?.(agenda, { forceShow: true });
            }}
            className="text-info text-center"
            style={DROPDOWN_ITEM_STYLE}
          >
            Ir Para Agenda
          </Dropdown.Item>

          <Dropdown.Divider style={{ margin: '0.2rem 0' }} />

          <Dropdown.Item
            onClick={() => setShowFaturamentoModal(true)}
            className="text-warning text-center"
            style={DROPDOWN_ITEM_STYLE}
          >
            FATURAMENTO
          </Dropdown.Item>

          <Dropdown.Divider style={{ margin: '0.2rem 0' }} />

          <Dropdown.Item
            onClick={handleAtividades}
            className="text-success text-center"
            style={DROPDOWN_ITEM_STYLE}
          >
            Anexar ECG
          </Dropdown.Item>
          <Dropdown.Item
            onClick={() => atualizarCampo('ecg', 'X')}
            className="text-success text-center"
            style={DROPDOWN_ITEM_STYLE}
          >
            Alterar ECG
          </Dropdown.Item>
          <Dropdown.Item
            onClick={() => atualizarCampo('confirma', 'Confirmada')}
            className="text-success text-center"
            style={DROPDOWN_ITEM_STYLE}
          >
            Confirmada
          </Dropdown.Item>

          <Dropdown.Divider style={{ margin: '0.2rem 0' }} />

          {[
            'Em Preparo',
            'Em Eletro',
            'Em Atendimento',
            'Atendido',
            'Cancelado',
            'Faltou',
            'Marcada',
            'Não Realizou',
            'Reservado',
          ].map((status) => (
            <Dropdown.Item
              key={status}
              onClick={() => atualizarSituacao(status)}
              className="text-primary text-center"
              style={DROPDOWN_ITEM_STYLE}
            >
              {status === 'Cancelado'
                ? `Cancelar Agenda`
                : status === 'Reservado'
                  ? `Horário ${status}`
                  : status === 'Marcada'
                    ? `Agenda Marcada`
                    : `Paciente ${status}`}
            </Dropdown.Item>
          ))}

          <Dropdown.Divider style={{ margin: '0.2rem 0' }} />

          <Dropdown.Item
            onClick={() => setShowAdvanced(!showAdvanced)}
            className="text-muted text-center"
            style={DROPDOWN_ITEM_STYLE}
          >
            {showAdvanced ? 'Ocultar avançado' : 'Mostrar avançado'}
          </Dropdown.Item>

          {showAdvanced && (
            <>
              {['Desmarcada', 'Aberta', 'Solicitado', 'Chamado'].map((status) => (
                <Dropdown.Item
                  key={status}
                  onClick={() => atualizarSituacao(status)}
                  className="text-primary text-center"
                  style={DROPDOWN_ITEM_STYLE}
                >
                  {status === 'Desmarcada'
                    ? `Desmarcar Agenda`
                    : status === 'Aberta' || status === 'Marcada'
                      ? `Agenda ${status}`
                      : `Paciente ${status}`}
                </Dropdown.Item>
              ))}

              <Dropdown.Divider style={{ margin: '0.2rem 0' }} />

              <Dropdown.Item
                onClick={() => atualizarSituacao('Laudado')}
                className="text-success text-center"
                style={DROPDOWN_ITEM_STYLE}
              >
                ECG EXT Laudado
              </Dropdown.Item>

              <Dropdown.Item
                onClick={onToggleCanceladas}
                className="text-danger text-center"
                style={DROPDOWN_ITEM_STYLE}
              >
                {verCanceladas ? 'Ocultar Canceladas' : 'Ver Canceladas'}
              </Dropdown.Item>
              <Dropdown.Item
                onClick={() => atualizarCampo('laudado', 'Sim')}
                className="text-success text-center"
                style={DROPDOWN_ITEM_STYLE}
              >
                Liberado
              </Dropdown.Item>
            </>
          )}
        </Dropdown.Menu>
      </Dropdown>

      <FaturamentoModal
        show={showFaturamentoModal}
        onHide={() => setShowFaturamentoModal(false)}
        agenda={agenda}
        medicos={doctor}
        onFaturado={() => atualizarSituacao('Faturado')}
        codFunc={codFunc}
        nomeFunc={nomeFunc}
      />
    </>
  );
}
